import { clientTagService } from '../../helpers/services/clientTag.service'
import { sharedHelper } from '@/utils'

export const state = {
  list: [],
  status: { list: true, save: true },
}

export const CLIENT_TAG_MODULE = 'clientTag'

export const GET_ALL_TAGS = 'getAllTags'
export const CREATE_TAG = 'createTag'
export const UPDATE_TAG = 'updateTag'
export const DELETE_TAG = 'deleteTag'
export const ASSIGN_TAG = 'assignTag'
export const UNASSIGN_TAG = 'unassignTag'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'

export const actions = {
  [GET_ALL_TAGS]({ commit }) {
    commit(REQUESTING, 'list')
    return clientTagService.getAllTags().then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_TAG]({ commit, dispatch }, { payload }) {
    commit(REQUESTING, 'save')
    return clientTagService.createTag(payload).then(() => {
      commit(SUCCESS); dispatch(GET_ALL_TAGS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [UPDATE_TAG]({ commit, dispatch }, { uuid, payload }) {
    commit(REQUESTING, 'save')
    return clientTagService.updateTag(uuid, payload).then(() => {
      commit(SUCCESS); dispatch(GET_ALL_TAGS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [DELETE_TAG]({ commit, dispatch }, { uuid }) {
    commit(REQUESTING, 'save')
    return clientTagService.deleteTag(uuid).then(() => {
      commit(SUCCESS); dispatch(GET_ALL_TAGS); return true
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE); return false
    })
  },
  [ASSIGN_TAG](_ctx, { debtorCode, tagUuid }) {
    return clientTagService.assignTag(debtorCode, tagUuid).then(() => true).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); return false
    })
  },
  [UNASSIGN_TAG](_ctx, { debtorCode, tagUuid }) {
    return clientTagService.unassignTag(debtorCode, tagUuid).then(() => true).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); return false
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    state.list = data?.data || []
  },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
